module.exports = __webpack_public_path__ + "assets/b24.png";


//////////////////
// WEBPACK FOOTER
// ./images/boomerang-frames/b24.png
// module id = 610
// module chunks = 0